import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "flex-container-row gap10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_grid = _resolveComponent("grid")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    hasLoaded: _ctx.hasLoaded,
    class: "flex-item-node pad10"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.localize('equipmentBomHasDeviations')), 1),
      _createVNode(_component_grid, {
        data: _ctx.dataItems,
        columns: _ctx.columns,
        "initial-sort": _ctx.initialSort,
        style: {"max-width":"1200px"},
        class: "flex-item-node"
      }, {
        customTemplate1: _withCtx(({props}) => [
          _createElementVNode("div", _hoisted_2, [
            (props.dataItem.status === 'added')
              ? (_openBlock(), _createBlock(_component_my_icon, {
                  key: 0,
                  icon: "plus-circle",
                  color: "green"
                }))
              : _createCommentVNode("", true),
            (props.dataItem.status === 'removed')
              ? (_openBlock(), _createBlock(_component_my_icon, {
                  key: 1,
                  icon: "minus-circle",
                  color: "red"
                }))
              : _createCommentVNode("", true),
            (props.dataItem.status === 'changed')
              ? (_openBlock(), _createBlock(_component_my_icon, {
                  key: 2,
                  icon: "edit",
                  color: "blue"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, _toDisplayString(_ctx.localize(props.dataItem.status)), 1)
          ])
        ]),
        _: 1
      }, 8, ["data", "columns", "initial-sort"])
    ]),
    _: 1
  }, 8, ["hasLoaded"]))
}